import { Transaction } from '@near-wallet-selector/core';
import { BN } from 'bn.js';
import { utils } from 'near-api-js';
import { DEFAULT_GAS, MEMO } from '../../constants';
import { SwapStep } from '../common/types';

export const getGas = (gas: string) =>
  gas ? new BN(gas) : new BN('100000000000000');

export const getAmount = (amount: string) =>
  amount ? new BN(utils.format.parseNearAmount(amount) ?? 0) : new BN('0');

async function createRefTransactions({
  user,
  swapSteps,
}: {
  user: string;
  swapSteps: SwapStep[];
}): Promise<Transaction[]> {
  const transactions: Transaction[] = [];

  // works only for 1 and 2 steps route, if there will be 3 and more steps
  // in future - we'll need to update it
  const actionsList = swapSteps.map((swapStep, index, arr) => {
    const { amm, inputMint, outputMint, amountIn, minAmountOut } = swapStep;

    const commonActionInfo = {
      pool_id: amm.instanceId,
      token_in: inputMint,
      token_out: outputMint,
    };

    const isFirstSwapStep = index === 0;
    const isMultiHop = arr.length > 1;

    // for direct route specify both amount in & out
    if (!isMultiHop) {
      return {
        ...commonActionInfo,
        amount_in: amountIn.toString(),
        min_amount_out: minAmountOut.toString(),
      };
    }

    // for first step in multi hop we skip min amount out and specify iy only
    // on last step of swap route
    if (isFirstSwapStep) {
      return {
        ...commonActionInfo,
        amount_in: amountIn.toString(),
        min_amount_out: '0',
      };
    }

    // for last step we specify only min amount out - so we take all amount out from
    // prev step as amount in, and fail automatically if it's less then needed for min_amount_out
    return {
      pool_id: amm.instanceId,
      token_in: inputMint,
      token_out: outputMint,
      min_amount_out: minAmountOut.toString(),
    };
  });

  const { amm: commonAMM, inputMint, amountIn } = swapSteps[0];

  transactions.push({
    receiverId: inputMint,
    signerId: user,
    actions: [
      {
        type: 'FunctionCall',
        params: {
          methodName: 'ft_transfer_call',
          args: {
            receiver_id: commonAMM.contractId,
            amount: amountIn.toString(),
            msg: JSON.stringify({
              force: 0,
              actions: actionsList,
            }),
            memo: MEMO,
          },
          gas: DEFAULT_GAS,
          deposit: '1',
        },
      },
    ],
  });

  return transactions;
}

export { createRefTransactions };
